<script lang="ts" setup>
import type { RefresherCustomEvent } from '@ionic/vue';
const { t } = useEkI18n();
const { usingTouch } = useInputTracker();
const locations = useGetLocationByFitterIdStore();
await locations.setLocationByFitterId();
const locationsResult = computed(() => locations._getLocationByFitterId ?? []);
const { query: searchQuery, results: searchResults } = useSearch(locationsResult, ['Name']);
const selectedLocationId = ref<string>('');
const selectedLocationName = ref<string>('');
const locationItemsIsOpen = ref(false);

async function handleRefresh(event: RefresherCustomEvent) {
  await locations.setLocationByFitterId();
  event.target.complete();
}

async function openLocationItems(id: string, name: string) {
  await showLoading(t('loading.loading'));
  selectedLocationId.value = id;
  selectedLocationName.value = name;
  locationItemsIsOpen.value = true;
}

const userMessagesSearch = computed(() => {
  if (searchQuery.value.length === 0 && searchResults.value.length === 0) {
    return {
      icon: 'fa-fa fa-light fa-location-dot',
      header: t('search.noResultsHeader'),
      subheader: t('materials.userMessages.noLocations')
    };
  } else {
    return {
      icon: 'fa-fa fa-light fa-magnifying-glass',
      header: t('search.noResultsHeader'),
      subheader: t('search.noResultsText')
    };
  }
});

</script>

<template>
  <IonSearchbar
    v-model="searchQuery"
    inputmode="search"
    :placeholder="t('search.placeholder')"
    :debounce="300"
  />
  <IonContent>
    <IonRefresher
      slot="fixed"
      :disabled="!usingTouch"
      @ion-refresh="handleRefresh($event)"
    >
      <IonRefresherContent />
    </IonRefresher>
    <IonList>
      <IonItem
        v-for="item in searchResults"
        :key="item.ID"
        @click="openLocationItems(item.ID, item.Name)"
      >
        <div class="location-label-note">
          <IonLabel>
            {{ item.Name }}
          </IonLabel>
          <IonNote v-if="item.Alias && item.Alias.trim() !== '' && item.Alias.trim() !== item.Name.trim()">
            {{ item.Alias }}
          </IonNote>
        </div>
      </IonItem>
    </IonList>
    <Modal
      v-model:open="locationItemsIsOpen"
      :title="selectedLocationName"
      animation-direction="vertical"
    >
      <MaterialLocationItemsList :selected-location-id="selectedLocationId" />
    </Modal>
    <UserMessagesSearch
      v-if="searchResults.length === 0"
      :icon="userMessagesSearch.icon"
      :header="userMessagesSearch.header"
      :subheader="userMessagesSearch.subheader"
    />
  </IonContent>
</template>

<style scoped>
.location-label-note {
  display: flex;
  flex-direction: column;
  gap: 0.2rem; 
}
</style>
